import { render } from "./ContextSwitch.vue?vue&type=template&id=1bbeebde"
import script from "./ContextSwitch.vue?vue&type=script&lang=js"
export * from "./ContextSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__